import {
  accesscontroller1,
  accesscontroller2,
  accesscontroller3,
  accesscontroller4,
  accesscontrollerOutlook,
  accesscontrollerThumb,
  accessAuto1,
  accessAuto2,
  accessAuto3,
  accessAuto4,
  accessAutoOutlook,
  accessAutoThumb,
  accessKey1,
  accessKey2,
  accessKey3,
  accessKey4,
  accessKeyOutlook,
  accessKeyThumb,
  accessKeyM1,
  accessPro1,
  accessPro2,
  accessPro3,
  accessPro4,
  accessProOutlook,
  accessProThumb,
  apart1,
  apart2,
  apart3,
  apart4,
  apartThumb,
  deadbolt1,
  deadbolt2,
  deadbolt3,
  deadbolt4,
  deadboltThumb,
  deadboltM1,
  emlock1,
  emlock2,
  emlock3,
  emlock4,
  emlockThumb,
  emlockM1,
} from '@assets/images/main/access/product';

import {
  assetTag1,
  assetTag2,
  assetTag3,
  assetTag4,
  assetTagOutlook,
  orbroTag1,
  orbroTag2,
  orbroTag3,
  orbroTag4,
  orbroTagOutlook,
} from '@assets/images/main/beacon/product';
import {
  carTracking1,
  carTracking2,
  carTracking3,
  carTracking4,
  carTrackingKey1,
  carTrackingKey2,
  carTrackingKey3,
  carTrackingKey4,
  carTrackingKey5,
  enterpriseKit1,
  enterpriseKit2,
  enterpriseKit3,
  enterpriseKitTopology,
  ipCam1,
  ipCam2,
  ipCam3,
  ipCam4,
  ipCamKey1,
  ipCamKey2,
  ipCamKey3,
  ipThumb,
  l2SwitchOutlook,
  peopleTracking1,
  peopleTracking2,
  peopleTracking3,
  peopleTracking4,
  peopleTrackingKey1,
  peopleTrackingKey2,
  peopleTrackingKey3,
  peopleTrackingKey4,
  ptzCam1,
  ptzCam2,
  ptzCam3,
  ptzCam4,
  ptzCamKey1,
  ptzCamKey2,
  ptzCamKey3,
  ptzThumb,
  starterKit1,
  starterKit2,
  starterKit3,
  starterKit4,
  starterKit5,
  starterKit6,
  starterKit7,
  starterKit8,
  starterKit9,
  starterKitOutlook,
  starterKitTopology,
} from '@assets/images/main/camera';
import {
  cobot1,
  cobot2,
  cobot3,
  deliverPackage,
  deliverRobot1,
  deliverRobot2,
  disinfection1,
  disinfection2,
  loadingKiosk1,
  loadingKiosk2,
} from '@assets/images/main/integration';
import {
  bell1,
  bell2,
  bell3,
  bell4,
  bellOutlook,
  esl1,
  esl2,
  esl3,
  esl4,
  eslOutlook,
  idCard1,
  idCard2,
  idCard3,
  idCard4,
  idCard5,
  idCard6,
  idCard7,
  idCardOutlook,
  mCradle1,
  mCradle2,
  mCradle3,
  mCradle4,
  mCradle5,
  mCradle6,
  mCradle7,
  mCradleOutlook,
  mCradleThumb,
  mTag1,
  mTag2,
  mTag2_1,
  mTag2_2,
  mTag2_3,
  mTag2_4,
  mTag2_Outlook,
  mTag2_Thumb,
  mTag2_key1,
  mTag2_key2,
  mTag2_key3,
  mTag3,
  mTag4,
  mTagOutlook,
  mTagThumb,
  switch1,
  switch2,
  switch3,
  switch4,
  switchOutlook,
} from '@assets/images/main/iot/product';
import { osServer1, osServer2, osServer3 } from '@assets/images/main/os/product';
import {
  vehicleTrackingKit1,
  vehicleTrackingKit2,
  vehicleTrackingKit3,
  vehicleTrackingKitThumb,
  yardTrackingKit1,
  yardTrackingKit2,
  yardTrackingKit3,
  yardTrackingKitThumb,
} from '@assets/images/main/outdoor';
import {
  aoaOutlook,
  coinTagOutlook,
  edgeRtlsOutlook,
  gpsOutlook,
  l2switchOutlook,
  orbroAoaTagOutlook,
  plutoconProOutlook,
  slimtagOutlook,
  stickerTagOutlook,
  twintrackerBleOutlook,
  uwbTagOutlook,
} from '@assets/images/main/outlook';
import {
  aoaEnterpriseKit,
  aoaEnterpriseKitThumb,
  aoaStarterKit,
  aoaStarterKitThumb,
  assetTagBle1,
  assetTagBle2,
  assetTagBle3,
  assetTagBleOutlook,
  assetTracking1,
  assetTracking2,
  assetTracking3,
  assetTracking4,
  bleEnterpriseKit,
  bleStarterKit,
  bleStarterKit2,
  comfortKit1,
  comfortKit2,
  comfortKitThumb,
  edgeRtls1,
  serverPc,
  tagUwb1,
  tagUwb2,
  tagUwbOutlook,
  twinTracker1,
  twinTracker2,
  twinTracker3,
  twinTracker4,
  twinTracker5,
  twinTracker6,
  twintracker7,
  twinTrackerAoa1,
  twinTrackerAoa2,
  twinTrackerAoa3,
  twinTrackerAoaThumb,
  twinTrackerBracket,
  twinTrackerOutlook,
  uwbEnterpriseKit,
  uwbEnterpriseKitThumb,
  uwbStarterKit,
  uwbStarterKitThumb,
  uwbTag1,
  uwbTag2,
  workerTracking1,
} from '@assets/images/main/rtls/product';
import {
  airQuality1,
  airQuality2,
  airQuality3,
  airQuality4,
  coMeasure1,
  coMeasure2,
  coMeasure3,
  coMeasure4,
  loraGateway1,
  loraGateway2,
  loraGateway3,
  loraGateway4,
  loraSensor1,
  loraSensor2,
  loraSensor3,
  loraSensor4,
} from '@assets/images/main/sensor';
import { eslThumbnail, safetyBellThumbnail, switchThumbnail, twinTrackerThumbnail } from '@assets/images/main/thumbnail';
import {
  aoaEnterpriseTopology,
  aoaStarterTopology,
  bleEnterpriseTopology,
  bleStarterTopology,
  osAiTopology,
  osRtlsTopology,
  osServerTopology,
  osSwitchTopology,
  twintrackerUwbTopology,
  uwbEnterpriseTopology,
  uwbStarterTopology,
} from '@assets/images/main/topology';
import OsSwitch from '@pages/Main/OS/Products/OsSwitch';

export default {
  document: 'tài liệu',
  product: {
    accesscontroller: {
      thumbnail: accesscontrollerThumb,

      mini1: accesscontroller1,
      mini2: accesscontroller2,
      mini3: accesscontroller3,
      mini4: accesscontroller4,

      key1: accesscontroller1,
      key2: accesscontroller2,
      key3: accesscontroller3,

      outlook: [
        {
          title: '',
          desc: '',
          img: accesscontrollerOutlook,
        },
      ],

      redDot: 0,
    },

    accessauto: {
      thumbnail: accessAutoThumb,

      mini1: accessAuto1,
      mini2: accessAuto2,
      mini3: accessAuto3,
      mini4: accessAuto4,

      key1: accessAuto1,
      key2: accessAuto3,
      key3: accessAuto2,

      outlook: [
        {
          title: '',
          desc: '',
          img: accessAutoOutlook,
        },
      ],

      redDot: 1,
      download: [
        {
          name: 'Access Auto - Datasheet v 1.0',
          date: '2023-11-20',
          data: 'Access Auto',
        },
      ],
    },

    apart: {
      thumbnail: apartThumb,

      mini1: apart1,
      mini2: apart2,
      mini3: apart3,
      mini4: apart4,

      key1: apart2,
      key2: apart4,
      key3: apart3,
      key4: accessAuto1,

      outlook: [
        {
          title: '',
          desc: '',
          img: accessAutoOutlook,
        },
      ],

      redDot: 0,
    },

    cloud: {
      thumbnail: accessAutoThumb,

      mini1: accessAuto1,
      mini2: accessAuto2,
      mini3: accessAuto3,
      mini4: accessAuto4,

      key1: accessAuto1,
      key2: accessAuto3,
      key3: accessAuto2,

      outlook: [
        {
          title: '',
          desc: '',
          img: accessAutoOutlook,
        },
      ],

      download: [
        {
          name: 'Access Auto - Datasheet v 1.0',
          date: '2023-11-20',
          data: 'Access Auto',
        },
      ],
      redDot: 1,
    },

    accesspro: {
      thumbnail: accessProThumb,

      mini1: accessPro1,
      mini2: accessPro2,
      mini3: accessPro3,
      mini4: accessPro4,

      key1: accessPro1,
      key2: accessPro2,
      key3: accessPro4,

      outlook: [
        {
          title: '',
          desc: '',
          img: accessProOutlook,
        },
      ],
      download: [
        {
          name: 'Access Pro - Datasheet v 1.0',
          date: '2023-11-20',
          data: 'Access Pro',
        },
      ],

      redDot: 0,
    },

    accesskey: {
      thumbnail: accessKeyThumb,

      mini1: accessKeyM1,
      mini2: accessKey2,
      mini3: accessKey3,
      mini4: accessKey4,

      key1: accessKeyM1,
      key2: accessKey2,
      key3: accessKey3,

      outlook: [
        {
          title: '',
          desc: '',
          img: accessKeyOutlook,
        },
      ],

      redDot: 0,
    },

    emlock: {
      thumbnail: emlockThumb,

      mini1: emlockM1,
      mini2: emlock2,
      mini3: emlock3,
      mini4: emlock4,

      key1: emlockM1,
      key2: emlock2,
      key3: emlock3,

      outlook: '',

      redDot: 0,
    },

    deadbolt: {
      thumbnail: deadboltThumb,

      mini1: deadboltM1,
      mini2: deadbolt2,
      mini3: deadbolt3,
      mini4: deadbolt4,

      key1: deadboltM1,
      key2: deadbolt2,
      key3: deadbolt3,

      outlook: '',

      redDot: 0,
    },

    autoDoorSensor: {
      thumbnail: accessAutoThumb,

      mini1: accessAuto1,
      mini2: accessAuto2,
      mini3: accessAuto3,
      mini4: accessAuto4,

      key1: accessAuto1,
      key2: accessAuto3,
      key3: accessAuto2,

      outlook: [
        {
          title: '',
          desc: '',
          img: accessAutoOutlook,
        },
      ],

      redDot: 0,
    },

    twinTracker: {
      design: [
        {
          title: '',
          desc: '',
          img1: twinTracker6,
          img2: twinTracker3,
          img3: twintracker7,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: twinTracker6,

      mini1: twinTracker6,
      mini2: twinTracker3,
      mini3: twintracker7,
      mini4: twinTracker5,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,

      outlook: [
        {
          title: 'TwinTracker BLE',
          desc: 'OTR-TTBT0001',
          img: assetTagBleOutlook,
        },
      ],
      title: 'TwinTracker',
      desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE mà không cần cài đặt phức tạp.',

      download: [
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      redDot: 0,
    },

    twinTrackerPro: {
      design: [
        {
          title: '',
          desc: '',
          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: twinTrackerThumbnail,

      mini1: twinTrackerThumbnail,
      mini2: twinTracker3,
      mini3: twinTracker4,
      mini4: twinTracker5,

      key1: assetTracking1,
      key2: assetTracking2,
      key3: assetTracking3,

      outlook: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],
      download: [
        {
          name: 'Twin Tracker Pro - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker Pro',
        },
      ],

      title: 'TwinTracker Pro',
      desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE mà không cần cài đặt phức tạp.',

      redDot: 0,
    },

    twinTrackerAoa: {
      design: [
        {
          title: '',
          desc: '',
          img1: twinTracker6,
          img2: twinTracker3,
          img3: twinTrackerAoa2,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: aoaOutlook,
        },
      ],

      thumbnail: twinTrackerAoaThumb,

      mini1: twinTrackerAoa3,
      mini2: twinTrackerAoa1,
      mini3: twinTrackerAoa2,
      mini4: twinTrackerBracket,

      key1: twinTrackerAoa3,
      key2: twinTrackerAoa1,
      key3: twinTrackerAoa2,

      outlook: [
        {
          title: 'TwinTracker AoA',
          desc: 'OTR-TTAO0001',
          img: aoaOutlook,
        },
      ],
      title: 'TwinTracker AoA',
      desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE mà không cần cài đặt phức tạp.',

      download: [
        {
          name: 'Twin Tracker AoA - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker AoA',
        },
      ],

      redDot: 0,
    },

    aoaStarterKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: aoaStarterKit,
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTrackerAoa3,
          img3: twinTrackerAoa1,
        },
      ],

      out: [
        {
          title: 'TwinTracker AoA',
          desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag (BLE)',
          desc: 'Gắn dễ dàng để theo dõi vị trí của người dùng.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: aoaStarterKitThumb,

      mini1: aoaStarterKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTrackerAoa3,

      key1: aoaStarterKit,
      key2: edgeRtls1,
      key3: starterKit3,

      topology: aoaStarterTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker AoA',
          desc: 'OTR-TTAO0001',
          img: aoaOutlook,
        },
        {
          title: 'ORBRO AoA Tag',
          desc: 'OAS-OTAO1991',
          img: orbroAoaTagOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'Twin Tracker AoA - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker AoA',
        },
      ],

      title: 'TwinTracker AoA Starter Kit',
      desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',

      redDot: 0,
    },

    aoaEnterpriseKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: aoaEnterpriseKit,
          img2: '',
          img3: '',
          img4: enterpriseKit2,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTrackerAoa3,
          img3: twinTrackerAoa1,
        },
      ],

      out: [
        {
          title: 'TwinTracker AoA',
          desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag (BLE)',
          desc: 'Gắn dễ dàng để theo dõi vị trí của người dùng.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: aoaEnterpriseKitThumb,

      mini1: aoaEnterpriseKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTrackerAoa3,

      key1: assetTracking1,
      key2: assetTracking2,
      key3: assetTracking3,

      topology: aoaEnterpriseTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker AoA',
          desc: 'OTR-TTAO0001',
          img: aoaOutlook,
        },
        {
          title: 'ORBRO AoA Tag',
          desc: 'OAS-OTAO1991',
          img: orbroAoaTagOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'Twin Tracker AoA - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker AoA',
        },
      ],

      title: 'TwinTracker AoA Enterprise Kit',
      desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',

      redDot: 0,
    },

    twinTrackerUwb: {
      design: [
        {
          title: '',
          desc: '',
          img1: twinTracker6,
          img2: twinTracker3,
          img3: twintracker7,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: twinTracker6,

      mini1: twinTracker6,
      mini2: twinTracker3,
      mini3: twintracker7,
      mini4: twinTracker5,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,

      topology: twintrackerUwbTopology,

      outlook: [
        {
          title: 'TwinTracker UWB',
          desc: 'OTR-TTUW0001',
          img: twintrackerBleOutlook,
        },
      ],
      title: 'TwinTracker UWB',
      desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',

      download: [
        {
          name: 'Twin Tracker UWB - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker UWB',
        },
      ],

      redDot: 0,
    },

    uwbStarterKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: uwbStarterKit,
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTracker6,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: 'TwinTracker UWB',
          desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag (BLE)',
          desc: 'Gắn dễ dàng để theo dõi vị trí của người dùng.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: uwbStarterKitThumb,

      mini1: uwbStarterKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTracker6,

      key1: uwbStarterKit,
      key2: edgeRtls1,
      key3: starterKit3,

      topology: uwbStarterTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker UWB',
          desc: 'OTR-TTUW0001',
          img: twintrackerBleOutlook,
        },
        {
          title: 'UWB Tag',
          desc: 'OTR-UTUW2062',
          img: uwbTagOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'Twin Tracker UWB - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker UWB',
        },
      ],

      title: 'TwinTracker UWB Starter Kit',
      desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',

      redDot: 0,
    },

    uwbEnterpriseKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: uwbEnterpriseKit,
          img2: '',
          img3: '',
          img4: enterpriseKit2,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTracker6,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: 'TwinTracker UWB',
          desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag (BLE)',
          desc: 'Gắn dễ dàng để theo dõi vị trí của người dùng.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: uwbEnterpriseKitThumb,

      mini1: uwbEnterpriseKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTracker6,

      key1: assetTracking1,
      key2: assetTracking2,
      key3: assetTracking3,

      topology: uwbEnterpriseTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker UWB',
          desc: 'OTR-TTUW0001',
          img: twintrackerBleOutlook,
        },
        {
          title: 'UWB Tag',
          desc: 'OTR-UTUW2062',
          img: uwbTagOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'Twin Tracker UWB - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker UWB',
        },
      ],

      title: 'TwinTracker UWB Enterprise Kit',
      desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',

      redDot: 0,
    },
    bleStarterKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: bleStarterKit2,
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTracker6,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: 'TwinTracker BLE',
          desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE mà không cần cài đặt phức tạp.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag (BLE)',
          desc: 'Gắn dễ dàng để theo dõi vị trí của nhân viên.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: bleStarterKit2,

      mini1: bleStarterKit2,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTracker6,

      key1: bleStarterKit2,
      key2: edgeRtls1,
      key3: starterKit3,

      topology: bleStarterTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker BLE',
          desc: 'OTR-TTBT0001',
          img: twintrackerBleOutlook,
        },
        {
          title: 'ORBRO Tag',
          desc: 'OAS-OTBT1991',
          img: orbroTagOutlook,
        },
        {
          title: 'Plutocon Pro',
          desc: 'KB-BK02',
          img: plutoconProOutlook,
        },
        {
          title: 'Coin Tag',
          desc: 'CD16BTR01X',
          img: coinTagOutlook,
        },
        {
          title: 'Slim Tag',
          desc: 'CD16BTS01X',
          img: slimtagOutlook,
        },
        {
          title: 'Sticker Tag',
          desc: 'CD16BTS01X',
          img: stickerTagOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      title: 'Ble Starter Kit',
      desc: 'Gói khởi động BLE bao gồm ORBRO Edge RTLS và TwinTracker BLE, cho phép triển khai nhanh hệ thống theo dõi tài sản dựa trên BLE.',

      redDot: 0,
    },

    bleEnterpriseKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: bleEnterpriseKit,
          img2: '',
          img3: '',
          img4: enterpriseKit2,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTracker6,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: 'TwinTracker BLE',
          desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE mà không cần cài đặt phức tạp.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag (BLE)',
          desc: 'Gắn dễ dàng để theo dõi vị trí của nhân viên.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: bleEnterpriseKit,

      mini1: bleEnterpriseKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTracker6,

      key1: assetTracking1,
      key2: assetTracking2,
      key3: assetTracking3,

      topology: bleEnterpriseTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker BLE',
          desc: 'OTR-TTBT0001',
          img: twintrackerBleOutlook,
        },
        {
          title: 'ORBRO Tag',
          desc: 'OAS-OTBT1991',
          img: orbroTagOutlook,
        },
        {
          title: 'Plutocon Pro',
          desc: 'KB-BK02',
          img: plutoconProOutlook,
        },
        {
          title: 'Coin Tag',
          desc: 'CD16BTR01X',
          img: coinTagOutlook,
        },
        {
          title: 'Slim Tag',
          desc: 'CD16BTS01X',
          img: slimtagOutlook,
        },
        {
          title: 'Sticker Tag',
          desc: 'CD16BTS01X',
          img: stickerTagOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      title: 'Ble Enterprise Kit',
      desc: 'Gói doanh nghiệp BLE với ORBRO Edge RTLS, L2 Switch và TwinTracker BLE tối ưu cho quy mô lớn.',

      redDot: 0,
    },
    comfortKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: comfortKit1,
          img2: uwbTag1,
          img3: uwbTag2,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: comfortKitThumb,

      mini1: comfortKitThumb,
      mini2: comfortKit2,
      mini3: uwbTag1,
      mini4: uwbTag2,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,

      outlook: [
        {
          title: 'UWB Tag',
          desc: 'OTR-UTUW2062',
          img: uwbTagOutlook,
        },
      ],
      title: 'Comfort Kit',
      desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',

      download: [
        {
          name: 'Comfort Kit - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Comfort Kit',
        },
      ],

      redDot: 0,
    },

    gpsDevice: {
      design: [
        {
          title: '',
          desc: '',
          img1: vehicleTrackingKit1,
          img2: '',
          img3: '',
        },
        {
          title: '',
          desc: '',
          img1: enterpriseKit2,
          img2: vehicleTrackingKit2,
          img3: vehicleTrackingKit3,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: vehicleTrackingKitThumb,

      mini1: vehicleTrackingKit1,
      mini2: enterpriseKit2,
      mini3: vehicleTrackingKit2,
      mini4: vehicleTrackingKit3,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,

      outlook: [
        {
          title: 'Vehicle Tracking Kit',
          desc: 'OTR-GD4G2121',
          img: gpsOutlook,
        },
      ],
      title: 'Vehicle Tracking Kit',
      desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',

      download: [
        {
          name: 'Vehicle Tracking Kit - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Vehicle Tracking Kit',
        },
      ],

      redDot: 0,
    },

    gpsTag: {
      design: [
        {
          title: '',
          desc: '',
          img1: yardTrackingKitThumb,
          img2: '',
          img3: '',
        },
        {
          title: '',
          desc: '',
          img1: enterpriseKit2,
          img2: loraGateway1,
          img3: loraGateway2,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: yardTrackingKit2,
          img3: yardTrackingKit3,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: yardTrackingKitThumb,

      mini1: yardTrackingKitThumb,
      mini2: enterpriseKit2,
      mini3: loraGateway1,
      mini4: yardTrackingKit2,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,

      title: 'Yard Tracking Kit',
      desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',

      download: [
        {
          name: 'Yard Tracking Kit - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Yard Tracking Kit',
        },
      ],

      redDot: 0,
    },

    workerTracking: {
      design: [
        {
          video: 'https://www.youtube.com/embed/l9l7AwAHTok?si=ZXWnI-855hhb7bPu',
          videoEng: 'https://www.youtube.com/embed/gXDb-OgylZw?si=pMbDUgO-FutPZqud',
          title: 'TwinTracker Pro',
          desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',

          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },

        {
          title: 'Tag (UWB)',
          desc: 'Gắn dễ dàng để theo dõi vị trí của nhân viên.',
          img1: '',
          img2: tagUwb1,
          img3: tagUwb2,
        },

        {
          title: 'Server PC',
          desc: 'Lưu trữ và tính toán vị trí của thiết bị.',
          img1: serverPc,
          img2: '',
          img3: '',
        },
      ],

      out: [
        {
          title: 'TwinTracker Pro',
          desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Tag (UWB)',
          desc: 'Gắn dễ dàng để theo dõi vị trí của nhân viên.',
          img: tagUwbOutlook,
        },
      ],

      thumbnail: workerTracking1,

      mini1: workerTracking1,
      mini2: tagUwb1,
      mini3: twinTracker1,
      mini4: assetTracking4,

      key1: workerTracking1,
      key2: tagUwb1,
      key3: twinTracker1,

      outlook: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'TwinTracker Pro - Datasheet v1.0',
          date: '2023-11-20',
          data: 'TwinTracker Pro',
        },
      ],
      title: 'TwinTracker Pro',
      desc: 'Dễ dàng theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE.',

      redDot: 0,
    },

    cameraEnterpriseKit: {
      design: [
        {
          video: 'https://www.youtube.com/embed/Z5dC0EKcnuY?si=zeRLmNn-RZXXcjF0',
          videoEng: 'https://www.youtube.com/embed/ZQ8mwjm3lBg?si=Y_89mX4kMcO3wKyl',
          title: 'PTZ Camera',
          desc: 'Theo dõi vị trí xe trong bãi đỗ qua camera PTZ.',
          img1: enterpriseKit1,
          img2: '',
          img3: '',
        },

        {
          title: 'NVR',
          desc: 'Lưu trữ và truyền phát hình ảnh camera.',
          img1: enterpriseKit2,
          img2: '',
          img3: '',
        },

        {
          title: 'Server PC',
          desc: 'Phân tích hình ảnh để tính toán vị trí.',
          img1: enterpriseKit3,
          img2: '',
          img3: '',
        },
      ],

      out: [],

      thumbnail: enterpriseKit1,

      mini1: enterpriseKit1,
      mini2: enterpriseKit3,
      mini3: enterpriseKit2,
      mini4: '',

      key1: '',
      key2: '',
      key3: '',

      outlook: '',
      topology: enterpriseKitTopology,

      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'NVR - Datasheet v1.0',
          date: '2023-11-20',
          data: 'NVR',
        },
        {
          name: 'PTZ Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'PTZ Camera',
        },
      ],

      title: '',
      desc: '',

      redDot: 0,
    },

    cameraStarterKit: {
      design: [
        {
          title: 'NVR',
          desc: 'Lưu trữ và truyền phát hình ảnh camera.',
          img1: starterKit1,
          img2: '',
          img3: '',
        },

        {
          title: 'Server PC',
          desc: 'Phân tích hình ảnh để tính toán vị trí.',
          img1: '',
          img2: starterKit2,
          img3: starterKit3,
        },
        {
          title: 'Server PC',
          desc: 'Phân tích hình ảnh để tính toán vị trí.',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
      ],

      out: [],

      thumbnail: starterKit2,

      mini1: starterKit1,
      mini2: starterKit2,
      mini3: starterKit4,
      mini4: starterKit5,

      key1: '',
      key2: '',
      key3: '',

      outlook: [
        {
          title: 'ORBRO Edge AI',
          desc: 'ONT-EAWF0001',
          img: starterKitOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2SwitchOutlook,
        },
      ],
      topology: starterKitTopology,
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'NVR - Datasheet v1.0',
          date: '2023-11-20',
          data: 'NVR',
        },
        {
          name: 'IP Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'IP Camera',
        },
      ],

      title: '',
      desc: '',

      redDot: 0,
    },
    osServer: {
      design: [
        {
          img1: osServer1,
          img2: '',
          img3: '',
          img4: osServer2,
        },
      ],

      out: [],

      thumbnail: osServer1,

      mini1: osServer1,
      mini2: osServer2,
      mini3: osServer3,

      key1: '',
      key2: '',
      key3: '',

      topology: osServerTopology,

      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'NVR - Datasheet v1.0',
          date: '2023-11-20',
          data: 'NVR',
        },
        {
          name: 'IP Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'IP Camera',
        },
      ],

      title: 'ORBRO Server',
      desc: 'Máy chủ back-end tích hợp ORBRO OS, cung cấp giao diện định vị thời gian thực và lưu trữ dữ liệu.',

      redDot: 0,
    },

    osRtls: {
      design: [
        {
          img1: edgeRtls1,
          img2: '',
          img3: '',
        },
        {
          img1: '',
          img2: starterKit3,
          img3: starterKit6,
        },
        {
          img1: '',
          img2: starterKit7,
          img3: starterKit8,
        },
      ],

      out: [],

      thumbnail: edgeRtls1,

      mini1: edgeRtls1,
      mini2: starterKit3,
      mini3: starterKit8,
      mini4: starterKit6,

      key1: '',
      key2: '',
      key3: '',

      topology: osRtlsTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
      ],
      download: [
        {
          name: 'ORBRO Edge RTLS - Datasheet v1.0',
          date: '2023-11-20',
          data: 'ORBRO Edge RTLS',
        },
      ],

      title: 'ORBRO Edge RTLS',
      desc: 'Thiết bị compact hỗ trợ TDoA UWB, cho phép theo dõi trong nhà chính xác.',

      redDot: 0,
    },

    osAi: {
      design: [
        {
          img1: starterKit2,
          img2: '',
          img3: '',
        },
        {
          img1: '',
          img2: starterKit3,
          img3: starterKit6,
        },
        {
          img1: '',
          img2: starterKit7,
          img3: starterKit8,
        },
      ],

      out: [],

      thumbnail: starterKit2,

      mini1: starterKit2,
      mini2: starterKit3,
      mini3: starterKit8,
      mini4: starterKit6,

      key1: '',
      key2: '',
      key3: '',

      topology: osAiTopology,

      outlook: [
        {
          title: 'ORBRO Edge AI',
          desc: 'ONT-EAWF0001',
          img: starterKitOutlook,
        },
      ],
      download: [
        {
          name: 'ORBRO Edge AI - Datasheet v1.0',
          date: '2023-11-20',
          data: 'ORBRO Edge AI',
        },
      ],

      title: 'ORBRO Edge AI',
      desc: 'Giải pháp AI biên cho phân tích video, cung cấp People Counting và phân tích lưu lượng.',

      redDot: 0,
    },

    osSwitch: {
      design: [
        {
          img1: starterKit4,
          img2: '',
          img3: '',
        },
        {
          img1: '',
          img2: starterKit5,
          img3: starterKit9,
        },
        {
          img1: '',
          img2: starterKit7,
          img3: starterKit8,
        },
      ],

      out: [],

      thumbnail: starterKit4,

      mini1: starterKit4,
      mini2: starterKit5,
      mini3: starterKit8,
      mini4: starterKit9,

      key1: '',
      key2: '',
      key3: '',

      topology: osSwitchTopology,

      outlook: [
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2SwitchOutlook,
        },
      ],
      download: [
        {
          name: 'L2 Switch - Datasheet v1.0',
          date: '2023-11-20',
          data: 'L2 Switch',
        },
      ],

      title: 'ORBRO L2 Switch',
      desc: 'Hub switch chuyên dụng hỗ trợ PoE 40W, giám sát và quản lý qua web/app.',

      redDot: 0,
    },

    ptz: {
      design: [
        {
          title: 'PTZ Camera',
          desc: 'Theo dõi vị trí xe qua camera PTZ ngoài trời.',
          img1: ptzCamKey1,
          img2: ptzCamKey2,
          img3: ptzCamKey3,
        },
      ],

      out: [],

      thumbnail: ptzThumb,

      mini1: ptzCam1,
      mini2: ptzCam2,
      mini3: ptzCam3,
      mini4: ptzCam4,

      key1: '',
      key2: '',
      key3: '',

      outlook: '',
      download: [
        {
          name: 'PTZ Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'PTZ Camera',
        },
      ],

      title: 'PTZ Camera',
      desc: 'Camera PTZ chuyên dụng ngoài trời với zoom quang 42x, độ phân giải 2K.',

      redDot: 0,
    },

    ip: {
      design: [
        {
          title: 'IP Camera',
          desc: 'Theo dõi lưu lượng trong nhà qua camera IP.',
          img1: ipCamKey1,
          img2: ipCamKey2,
          img3: ipCamKey3,
        },
      ],

      out: [],

      thumbnail: ipThumb,

      mini1: ipCam1,
      mini2: ipCam2,
      mini3: ipCam3,
      mini4: ipCam4,

      key1: '',
      key2: '',
      key3: '',

      outlook: '',
      download: [
        {
          name: 'IP Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'IP Camera',
        },
      ],

      title: 'IP Camera',
      desc: 'Camera 1080p với lựa chọn 2.8/4mm, chuẩn IP67 cho môi trường khắc nghiệt.',

      redDot: 0,
    },
    safetyBell: {
      thumbnail: safetyBellThumbnail,

      mini1: bell1,
      mini2: bell2,
      mini3: bell3,
      mini4: bell4,

      key1: bell1,
      key2: bell2,
      key3: bell3,

      outlook: [
        {
          title: '',
          desc: '',
          img: bellOutlook,
        },
      ],
      download: [
        {
          name: 'Safety Bell - Datasheet v 1.0',
          date: '2023-11-20',
          data: 'Safety Bell',
        },
      ],

      redDot: 0,
    },

    smartSwitch: {
      thumbnail: switchThumbnail,

      mini1: switch1,
      mini2: switch2,
      mini3: switch3,
      mini4: switch4,

      key1: switch1,
      key2: switch2,
      key3: switch3,

      outlook: [
        {
          title: '',
          desc: '',
          img: switchOutlook,
        },
      ],
      download: [
        {
          name: 'Smart Switch - Datasheet v 1.0',
          date: '2023-11-20',
          data: 'Smart Switch',
        },
      ],

      redDot: 0,
    },

    esl: {
      thumbnail: eslThumbnail,

      mini1: esl1,
      mini2: esl2,
      mini3: esl3,
      mini4: esl4,

      key1: esl1,
      key2: esl2,
      key3: esl3,

      outlook: [
        {
          title: '',
          desc: '',
          img: eslOutlook,
        },
      ],
      download: [
        {
          name: 'E-ink Display - Datasheet v 1.0',
          date: '2023-11-20',
          data: 'E-ink Display',
        },
      ],

      redDot: 0,
    },

    mTag: [
      {
        thumbnail: mTagThumb,

        mini1: mTag1,
        mini2: mTag2,
        mini3: mTag3,
        mini4: mTag4,

        key1: mTag1,
        key2: mTag2,
        key3: mTag3,

        outlook: [
          {
            title: '',
            desc: '',
            img: mTagOutlook,
          },
        ],
        redDot: 1,
      },

      {
        thumbnail: mTag2_Thumb,

        mini1: mTag2_1,
        mini2: mTag2_2,
        mini3: mTag2_3,
        mini4: mTag2_4,

        key1: mTag2_key1,
        key2: mTag2_key2,
        key3: mTag2_key3,

        outlook: [
          {
            title: '',
            desc: '',
            img: mTag2_Outlook,
          },
        ],
        redDot: 1,
      },
    ],

    mCradle: {
      thumbnail: mCradleThumb,

      mini1: mCradle1,
      mini2: mCradle2,
      mini3: mCradle3,
      mini4: mCradle4,

      key1: mCradle5,
      key2: mCradle6,
      key3: mCradle7,

      outlook: [
        {
          title: '',
          desc: '',
          img: mCradleOutlook,
        },
      ],

      redDot: 0,
    },

    idCard: {
      thumbnail: idCard1,

      mini1: idCard1,
      mini2: idCard2,
      mini3: idCard3,
      mini4: idCard4,

      key1: idCard5,
      key2: idCard6,
      key3: idCard7,

      outlook: [
        {
          title: '',
          desc: '',
          img: idCardOutlook,
        },
      ],

      redDot: 0,
    },

    loraGateway: {
      thumbnail: loraGateway1,

      mini1: loraGateway1,
      mini2: loraGateway2,
      mini3: loraGateway3,
      mini4: loraGateway4,

      key1: loraGateway1,
      key2: loraGateway2,
      key3: loraGateway3,

      outlook: '',

      redDot: 0,
    },

    loraSensor: {
      thumbnail: loraSensor1,

      mini1: loraSensor1,
      mini2: loraSensor2,
      mini3: loraSensor3,
      mini4: loraSensor4,

      key1: loraSensor1,
      key2: loraSensor2,
      key3: loraSensor3,

      outlook: '',

      redDot: 0,
    },

    airQuality: {
      thumbnail: airQuality1,

      mini1: airQuality1,
      mini2: airQuality2,
      mini3: airQuality3,
      mini4: airQuality4,

      key1: airQuality1,
      key2: airQuality2,
      key3: airQuality3,

      outlook: '',

      redDot: 0,
    },

    coMeasure: {
      thumbnail: coMeasure1,

      mini1: coMeasure1,
      mini2: coMeasure2,
      mini3: coMeasure3,
      mini4: coMeasure4,

      key1: coMeasure1,
      key2: coMeasure2,
      key3: coMeasure3,

      outlook: '',

      redDot: 0,
    },

    plutoconPro: {
      thumbnail: accesscontrollerThumb,

      mini1: accesscontroller1,
      mini2: accesscontroller2,
      mini3: accesscontroller3,
      mini4: accesscontroller4,

      key1: accesscontroller1,
      key2: accesscontroller2,
      key3: accesscontroller3,

      outlook: [
        {
          title: '',
          desc: '',
          img: accesscontrollerOutlook,
        },
      ],
      download: [
        {
          name: 'Plutocon Pro - Datasheet v 1.0',
          date: '2023-11-20',
          data: 'Plutocon Pro',
        },
      ],

      redDot: 0,
    },

    orbroTag: {
      thumbnail: orbroTag1,

      mini1: orbroTag1,
      mini2: orbroTag2,
      mini3: orbroTag3,
      mini4: orbroTag4,

      key1: orbroTag1,
      key2: orbroTag2,
      key3: orbroTag3,

      outlook: [
        {
          title: '',
          desc: '',
          img: orbroTagOutlook,
        },
      ],
      download: [
        {
          name: 'ORBRO Tag - Datasheet v 1.0',
          date: '2023-11-20',
          data: 'ORBRO Tag',
        },
      ],

      redDot: 0,
    },

    assetTag: {
      thumbnail: assetTag1,

      mini1: assetTag1,
      mini2: assetTag2,
      mini3: assetTag3,
      mini4: assetTag4,

      key1: assetTag1,
      key2: assetTag4,
      key3: assetTag3,

      outlook: [
        {
          title: '',
          desc: '',
          img: assetTagOutlook,
        },
      ],

      redDot: 0,
    },

    robotBasic: {
      design: [
        {
          title: 'Delivery Robot',
          desc: 'Thực hiện giao hàng thông qua tích hợp với hệ thống ORBRO.',
          img2: deliverRobot1,
          img3: deliverRobot2,
        },
        {
          title: 'Twin Tracker Pro',
          desc: 'Theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE mà không cần cài đặt phức tạp.',
          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },
        {
          title: 'Tag(UWB)',
          desc: 'Gắn dễ dàng để theo dõi vị trí của nhân viên.',
          img2: tagUwb1,
          img3: tagUwb2,
        },
        {
          title: 'Server PC',
          desc: 'Lưu trữ và tính toán vị trí của tài sản.',
          img1: serverPc,
          img2: '',
          img3: '',
        },
      ],
      out: [],
      thumbnail: deliverRobot1,
      mini1: deliverRobot1,
      mini2: tagUwb1,
      mini3: twinTracker1,
      mini4: assetTracking4,
      key1: '',
      key2: '',
      key3: '',
      outlook: '',
      title: '',
      desc: '',
      redDot: 0,
    },

    delivery: {
      design: [
        {
          title: 'Delivery Robot',
          desc: 'Thực hiện giao hàng thông qua tích hợp với hệ thống ORBRO.',
          img2: deliverRobot1,
          img3: deliverRobot2,
        },
        {
          title: 'Loa tích hợp tích hợpding Kiosk',
          desc: 'Đặt hàng lên thiết bị và khi gọi robot, sẽ tự động xếp hàng lên robot.',
          img2: loadingKiosk1,
          img3: loadingKiosk2,
        },
        {
          title: 'Cobot',
          desc: 'Khi robot giao hàng đến, chịu trách nhiệm dỡ hàng từ robot.',
          img2: cobot3,
          img3: cobot2,
        },
        {
          title: 'Twin Tracker Pro',
          desc: 'Theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE mà không cần cài đặt phức tạp.',
          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },
        {
          title: 'Tag(UWB)',
          desc: 'Gắn dễ dàng để theo dõi vị trí của nhân viên.',
          img2: tagUwb1,
          img3: tagUwb2,
        },
        {
          title: 'Server PC',
          desc: 'Lưu trữ và tính toán vị trí của tài sản.',
          img1: serverPc,
          img2: '',
          img3: '',
        },
      ],
      out: [],
      thumbnail: deliverPackage,
      mini1: deliverPackage,
      mini2: loadingKiosk2,
      mini3: cobot1,
      mini4: workerTracking1,
      key1: '',
      key2: '',
      key3: '',
      outlook: '',
      title: '',
      desc: '',
      redDot: 0,
    },

    disinfection: {
      design: [
        {
          title: 'Delivery Robot',
          desc: 'Thực hiện giao hàng thông qua tích hợp với hệ thống ORBRO.',
          img2: deliverRobot1,
          img3: deliverRobot2,
        },
        {
          title: 'Loa tích hợp tích hợpding Kiosk',
          desc: 'Đặt hàng lên thiết bị và khi gọi robot, sẽ tự động xếp hàng lên robot.',
          img2: loadingKiosk1,
          img3: loadingKiosk2,
        },
        {
          title: 'Cobot',
          desc: 'Khi robot giao hàng đến, chịu trách nhiệm dỡ hàng từ robot.',
          img2: cobot3,
          img3: cobot2,
        },
        {
          title: 'Disinfection Device Kit',
          desc: 'Thiết bị chịu trách nhiệm khử trùng an toàn trong quá trình chất/xả hàng của robot giao hàng.',
          img1: disinfection2,
        },
        {
          title: 'Twin Tracker Pro',
          desc: 'Theo dõi tín hiệu không dây của thiết bị tag chỉ với kết nối PoE mà không cần cài đặt phức tạp.',
          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },
        {
          title: 'Tag(UWB)',
          desc: 'Gắn dễ dàng để theo dõi vị trí của nhân viên.',
          img2: tagUwb1,
          img3: tagUwb2,
        },
        {
          title: 'Server PC',
          desc: 'Lưu trữ và tính toán vị trí của tài sản.',
          img1: serverPc,
          img2: '',
          img3: '',
        },
      ],
      out: [],
      thumbnail: disinfection1,
      mini1: disinfection1,
      mini2: loadingKiosk2,
      mini3: cobot1,
      mini4: disinfection2,
      key1: '',
      key2: '',
      key3: '',
      outlook: '',
      title: '',
      desc: '',
      redDot: 0,
    },
  },
};
